export default {
  profile: {
    // personal details
    mail: "",
    password: "",
    password_confirmation: "",
    current_pass: "",
    field_personal_first_name: "",
    field_personal_middle_name: "",
    field_personal_last_name: "",
    field_personal_school_role: "",
    field_personal_age: null,
    field_personal_gender: null,
    field_personal_gender_other: null,
    field_school_address_country: null,
    field_personal_ethnicity_race: "",
    field_other_referral: "",
    field_personal_education_level: null,
    field_personal_student_age: "",
    field_personal_student_age_exact: [],
    field_personal_years_experience: null,
    field_personal_affiliation: "",
    field_personal_school_type: "",
    field_personal_school_type_other: "",

    // about the school
    field_school_address_line_1: "",
    field_school_address_line_2: "",
    field_school_address_city: "",
    field_school_address_state: "",
    field_school_address_district: "",
    field_school_contact_landline: "",
    field_school_contact_mobile: "",
    field_school_contact_email: "",

    // past experience
    field_exp_training: null,
    field_exp_programs: null,
  },
  errors: {},
};
